import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FAILED_STATUSES, PaymentsStatusEnum } from 'src/shared/models/enums/paymentsStatus.enum';
import { Tabs, Tab } from '@mui/material';

export interface PaymentsTabItem {
  label: string;
  key: string;
  values: number[];
}

interface PaymentsTabsProps {
  initialValue: PaymentsTabItem;
  disableAll: boolean;
  callback: (item: PaymentsTabItem) => void;
}

export const paymentsTabs: PaymentsTabItem[] = [
  {
    label: 'invoice:invoiceStatus.All',
    key: 'All',
    values: [PaymentsStatusEnum.All],
  },
  {
    label: 'invoice:payments.statusCompletedPlural',
    key: 'Completed',
    values: [PaymentsStatusEnum.Completed],
  },
  {
    label: 'invoice:payments.statusFailedPlural',
    key: 'Failed',
    values: FAILED_STATUSES,
  },
];

export const PaymentsTabs = ({ initialValue, disableAll, callback }: PaymentsTabsProps) => {
  const [value, setValue] = useState(initialValue.key);
  const { t } = useTranslation(['invoice']);

  useEffect(() => {
    setValue(initialValue.key);
  }, [initialValue.key]);

  const handleChange = (event: React.ChangeEvent<any>, newValue: string) => {
    setValue(newValue);
    callback(paymentsTabs.filter((x) => x.key === newValue)[0]);
  };

  return (
    <Tabs
      value={value}
      textColor='primary'
      onChange={handleChange}
      aria-label='status-tabs'
      sx={{
        '& button': {
          textTransform: 'none',
        },
      }}
    >
      {paymentsTabs.map((item) => (
        <Tab key={item.key} label={t(item.label)} value={item.key} disabled={disableAll} />
      ))}
    </Tabs>
  );
};
